export const FlowComponentModels = {
  1051: {
    name: '任务列表',
    component: () => import('../components/Task'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  },
  1052: {
    name: '邀请记录',
    component: () => import('../components/InviteRecord'),
    props: (_actData, componentDetail) => {
      return {
        id: 1052,
        ...componentDetail
      };
    }
  },
  1058: {
    name: '邀请记录(任务纬度)',
    component: () => import('../components/InviteRecord'),
    props: (_actData, componentDetail) => {
      return {
        id: 1058,
        ...componentDetail
      };
    }
  },
  2006: {
    name: '图片',
    component: () => import('@/components/templates/common/Image'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  },
  2007: {
    name: '活动资源位',
    component: () => import('@/components/templates/common/ActivityBoard'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  },
  2003: {
    name: '普通按钮',
    component: () => import('@/components/templates/common/PrimaryBtn'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  }
};
export const TopBoardCastModel = {
  id: 2010,
  name: '跑马灯',
  component: () => import('../components/BoardCast'),
  props: (_actData, componentDetail) => {
    return componentDetail;
  }
};
export const FooterBtnModel = {
  1053: {
    name: '吸底悬浮按钮',
    component: () => import('../components/FooterBtn'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  },
  2004: {
    name: '吸底悬浮按钮 普通组件',
    component: () => import('@/components/templates/common/FooterBtn'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  },
  2005: {
    name: '悬浮球',
    component: () => import('@/components/templates/common/FloatBtn'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  }
};

export const NavComponentsModels = {
  2001: {
    name: '我的奖品',
    component: () => import('@/components/templates/common/PinnedAwardsBtn'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  },
  2002: {
    name: '规则',
    component: () => import('@/components/templates/common/PinnedRuleBtn'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  },
  2009: {
    name: '我的奖品自定义',
    component: () => import('../components/Icon'),
    props: (_actData, componentDetail) => {
      return {
        ...componentDetail,
        text: '我的奖励',
        linkTo: '/my_awards'
      };
    }
  },
  2008: {
    name: '活动规则自定义',
    component: () => import('../components/Icon'),
    props: (_actData, componentDetail) => {
      return {
        ...componentDetail,
        text: '规则页',
        linkTo: '/rule'
      };
    }
  },
  1059: {
    name: '城市定位',
    component: () => import('../components/CityLocation'),
    props: (_actData, componentDetail) => {
      return {
        ...componentDetail
      };
    }
  }
};
export const MoneyComponentModel = {
  id: 1056,
  name: '金额',
  component: () => import('../components/Money'),
  props: (_actData, componentDetail) => {
    return componentDetail;
  }
};

export const flowComponents = {
  ...FlowComponentModels,
  ...FooterBtnModel,
  ...NavComponentsModels,
  1056: {
    name: '金额',
    component: () => import('../components/Money'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  },
  2010: {
    name: '跑马灯',
    component: () => import('../components/BoardCast'),
    props: (_actData, componentDetail) => {
      return componentDetail;
    }
  }
};
